import Logo from '../assets/navbar/logo.svg';
import Search from '../assets/navbar/search.svg';
import DoubleArrow from '../assets/navbar/doubleArrow.svg';
import Menu from '../assets/navbar/menu.svg';

import Assets from '../assets/sidebar/asset.svg';
import Debt from '../assets/sidebar/debt.svg';

import First from '../assets/navbar/group/first.png';
import Second from '../assets/navbar/group/second.png';
import Third from '../assets/navbar/group/third.png';
import Networth_Image from '../assets/networth/networth.svg';
import Track from '../assets/networth/track.svg';
import ErrorNetworth from '../assets/networth/error_networth.svg';
import LockNetworth from '../assets/networth/lock.svg';
import RetiremnetNew from '../assets/goalplanner/RetiremnetNew.svg';
import CarNew from '../assets/goalplanner/CarNew.svg';

import Stock from '../assets/assets_page/trackAssets/stocks.svg';
import Mutual from '../assets/assets_page/trackAssets/mutual.svg';
import gold from '../assets/assets_page/trackAssets/gold.svg';
import Networth from '../assets/customOptions/networth.svg';
import trackNetworth from '../assets/customOptions/tracknetworth.svg';
import ViewAssets from '../assets/customOptions/viewassets.svg';
import AssetDistribution from '../assets/customOptions/assetdistribution.svg';
import EducationNew from '../assets/goalplanner/EducationLoan.svg';
import Analysis from '../assets/customOptions/analysis.svg';
// GOAL Planner
import DownPayment from '../assets/planning/downpayment.svg';
import Home from '../assets/planning/home.svg';
import Mortage from '../assets/planning/mortage.svg';
import OtherGoal from '../assets/planning/othergoal.svg';

import SaveUp from '../assets/planning/saveup.svg';
import PayDown from '../assets/planning/paydown.svg';
import Car from '../assets/planning/car.svg';
import CreditCard from '../assets/planning/creditcards.svg';
import Education from '../assets/planning/education.svg';
import EmergencyFund from '../assets/planning/emergencyfunds.svg';
import Retirement from '../assets/planning/retirement.svg';
import Savings from '../assets/planning/savings.svg';
import StudentLoans from '../assets/planning/education.svg';
import Vacation from '../assets/planning/vacation.svg';
import VacationNew from '../assets/goalplanner/Vacation.svg';
import Wedding from '../assets/planning/wedding.svg';
import FamilyGoal from '../assets/goalfor/family.svg';
import PersonalGoal from '../assets/goalfor/personalgoal.svg';
import Goal from '../assets/goalfor/goal.svg';
import BasicInformation from '../assets/goalplanner/basic.svg';
import Marriagenew from '../assets/goalplanner/marriage.svg';
import Info from '../assets/goalplanner/info.svg';
import Loan from '../assets/goalplanner/Loan.svg';
import SavingNew from '../assets/goalplanner/savings.svg';
import EmergencyNew from '../assets/goalplanner/Emergency.svg';

import Calendar from '../assets/goalplanner/calendar.svg';
import RetirementLogo from '../assets/goalplanner/retirement.svg';
import Suggestions from '../assets/goalplanner/suggestions.svg';
import Perdictions from '../assets/goalplanner/predictions.png';

import Rupees from '../assets/goalplanner/rupees.svg';
import Sel_ect from '../assets/goalplanner/sel_ect.svg';
import Percentage from '../assets/goalplanner/percentage.png';
import Sucess from '../assets/goalplanner/sucess.png';
import GoalIn from '../assets/goalplanner/goalin.svg';
import GoalOut from '../assets/goalplanner/goalout.svg';
import MobileSucess from '../assets/goalplanner/mobile_sucess.png';
import MobilePercentage from '../assets/goalplanner/mobile_percentage.svg';
interface PaySave {
  id: string;
  title: string;
  icon: string; // Assuming icons are React components
  type: string; // Assuming type is one of two options
}
const saveUpGoals: PaySave[] = [
  {
    id: 'retirementGoal',
    title: 'Retirement',
    icon: Retirement,
    type: 'Save Up',
  },
  { id: 'homeGoal', title: 'Home', icon: Home, type: 'Save Up' },
  { id: 'vacationGoal', title: 'Vacation', icon: Vacation, type: 'Save Up' },
  { id: 'carGoal', title: 'Car', icon: Car, type: 'Save Up' },
  {
    id: 'emergencyFundsGoal',
    title: 'Emergency Funds',
    icon: EmergencyFund,
    type: 'Save Up',
  },
  { id: 'weddingGoal', title: 'Wedding', icon: Wedding, type: 'Save Up' },
  { id: 'educationGoal', title: 'Education', icon: Education, type: 'Save Up' },
  { id: 'savingsGoal', title: 'Savings', icon: Savings, type: 'Save Up' },
  {
    id: 'downPaymentGoal',
    title: 'Down Payment',
    icon: DownPayment,
    type: 'Save Up',
  },
  {
    id: 'otherGoalSaveUp',
    title: 'Other Goal',
    icon: OtherGoal,
    type: 'Save Up',
  },
];

const payDownGoals: PaySave[] = [
  {
    id: 'creditCardsGoal',
    title: 'Credit Cards',
    icon: CreditCard,
    type: 'Pay Down',
  },
  {
    id: 'studentLoansGoal',
    title: 'Student Loans',
    icon: StudentLoans,
    type: 'Pay Down',
  },
  { id: 'autoLoansGoal', title: 'Auto Loans', icon: Car, type: 'Pay Down' },
  { id: 'mortgageGoal', title: 'Mortgage', icon: Mortage, type: 'Pay Down' },
  {
    id: 'otherGoalPayDown',
    title: 'Other Goal',
    icon: OtherGoal,
    type: 'Pay Down',
  },
];
export {
  Logo,
  Search,
  DoubleArrow,
  Menu,
  Assets,
  Debt,
  First,
  Second,
  Third,
  Networth_Image,
  Track,
  ErrorNetworth,
  LockNetworth,
  Stock,
  Mutual,
  gold,
  Networth,
  trackNetworth,
  ViewAssets,
  AssetDistribution,
  Analysis,
  SaveUp,
  PayDown,
  Retirement,
  PersonalGoal,
  FamilyGoal,
  BasicInformation,
  Info,
  Calendar,
  RetirementLogo,
  Suggestions,
  Perdictions,
  Goal,
  Rupees,
  Sel_ect,
  Percentage,
  Sucess,
  GoalIn,
  GoalOut,
  MobilePercentage,
  MobileSucess,
  saveUpGoals,
  payDownGoals,
};

export const HeaderNames = {
  Authorization: 'Authorization',
  AdvisorID: 'X-Advisor-ID',
};

export const AUTH_TOKEN = 'token';
export const ADVISOR_ID = 'advisor_id';
export const USER_TYPE = 'user_type';
export const ADVISOR_TYPE = 'advisor';
export const CUSTOMER_TYPE = 'customer';

export const customStyles = {
  menu: provided => ({
    ...provided,
    maxHeight: '150px', // Limit the dropdown menu's height
    overflowY: 'auto', // Enable vertical scrolling
    borderRadius: '5px', // Rounded corners for the menu
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for the menu
    backgroundColor: '#fff', // Background color of the menu
  }),
  menuList: provided => ({
    ...provided,
    maxHeight: '150px', // Ensure the inner list doesn't exceed the parent height
    overflowY: 'auto', // Enable vertical scrolling for the list
    padding: '0', // Remove padding
    // Custom scrollbar
    '&::-webkit-scrollbar': {
      width: '6px', // Width of the scrollbar
    },
    '&::-webkit-scrollbar-track': {
      background: '##E4DFFF', // Track color
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#C6C0FA', // Thumb color
      marginTop: '4px',
      borderRadius: '5px', // Rounded corners for the thumb
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#C6C0FA', // Hover color for the thumb
    },
  }),
  control: (provided, state) => ({
    ...provided,
    height: '49px',
    border: '1px solid #e4e6ec',
    borderRadius: '10px',
    width: '200px',
    borderColor: state.isFocused ? '#8276f4' : '#e4e6ec', // Change border color on focus
    boxShadow: state.isFocused ? '0 0 0 2px rgba(130, 118, 244, 0.2)' : 'none', // Subtle shadow on focus
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '10px 15px', // Adjust padding for options
    fontSize: '12px', // Font size for options
    color: state.isSelected ? '#fff' : '#333', // Selected option text color
    fontWeight: '700',
    borderBottom: '1px solid #e4e6ec',
    backgroundColor: state.isSelected
      ? '#8276f4' // Background color for selected option
      : state.isFocused
      ? '#E4DFFF' // Background color on hover
      : '#fff', // Default background color
    cursor: 'pointer',
    '&:active': {
      backgroundColor: '#7C3EE6',
    },
  }),
};

export const goalIconsMap: Record<string, string> = {
  retirement: RetiremnetNew,
  home: Home,
  vacation: VacationNew,
  car: CarNew,
  emergency_funds: EmergencyNew,
  wedding: Marriagenew,
  education: EducationNew,
  savings: SavingNew,
  down_payment: Loan,
  other: OtherGoal,
  credit_cards: CreditCard,
  student_loans: EducationNew,
  auto_loans: CarNew,
  mortgage: Mortage,
  otherGoalPayDown: OtherGoal,
};
export const maskPhoneNumber = (phone: string | undefined | null): string => {
  if (!phone || typeof phone !== 'string' || phone.trim() === '') return '';

  const cleanedPhone = phone.startsWith('+91') ? phone.slice(3) : phone;
  if (cleanedPhone.length < 4) return `+91 ${cleanedPhone}`;

  return `+91 ${cleanedPhone.slice(0, 2)}${'*'.repeat(
    cleanedPhone.length - 4,
  )}${cleanedPhone.slice(-2)}`;
};

export const clientType: Record<string, string> = {
  CUSTOMER: 'Customer',
  GROUP_HEAD: 'Group Head',
  CLIENT: 'Client',
};
export const clientKycstatus: Record<string, string> = {
  PENDING: 'Pending',
  REJECTED: 'Rejected',
  APPROVED: 'Approved',
};

export const leadRecords: Record<string, number> = {
  '10 L - 20 L': 2000000,
  '20 L - 50 L': 5000000,
  '50 L - 80 L': 8000000,
  '80 L - 1 Cr.': 10000000,
  '1 Cr. - 3 Cr.': 30000000,
  '3 Cr. - 5 Cr.': 50000000,
};
export const reverseLeadRecords: Record<number, string> = Object.fromEntries(
  Object.entries(leadRecords).map(([key, value]) => [value, key]),
);
